import { Box, Portal, Tooltip as ChakraTooltip } from "@chakra-ui/react"
import * as React from "react"

export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement>
  content: React.ReactNode
  contentProps?: ChakraTooltip.ContentProps
  disabled?: boolean
  description?: string
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props, ref) {
  const {
    showArrow = false,
    children,
    disabled,
    portalled = true,
    content,
    contentProps,
    portalRef,
    interactive = false,
    closeDelay = 0,
    openDelay = 0,
    description,
    immediate = false,
    ...rest
  } = props

  if (disabled) return children

  const mergedContentProps: ChakraTooltip.ContentProps = {
    ...contentProps,
    css: {
      "--tooltip-bg": "var(--planner-colors-background, #F2F0EF)",
      bg: "var(--tooltip-bg)",
      color: "primary",
      fontSize: "0.8125rem",
      lineHeight: "1.35",
      fontWeight: "500",
      border: "1px solid",
      borderColor: "gray.300",
      borderRadius: "0.3125rem",
      padding: "0.375rem 0.625rem",
      boxShadow: "0 0.25rem 1rem rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08)",
      ...contentProps?.css,
    },
  }

  return (
    <ChakraTooltip.Root {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal container={portalRef} disabled={!portalled}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={ref} {...mergedContentProps}>
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip
                  borderColor="gray.300"
                  bg="var(--planner-colors-background, #F2F0EF)"
                />
              </ChakraTooltip.Arrow>
            )}
            {description || content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  )
})
